/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssuranceGridDto
 */
export interface AssuranceGridDto {
    /**
     * 
     * @type {number}
     * @memberof AssuranceGridDto
     */
    idsiegeSocialCompagnieAssurance?: number;
    /**
     * 
     * @type {number}
     * @memberof AssuranceGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof AssuranceGridDto
     */
    compagnieAssurance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssuranceGridDto
     */
    numeroPolice?: string | null;
}

/**
 * Check if a given object implements the AssuranceGridDto interface.
 */
export function instanceOfAssuranceGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssuranceGridDtoFromJSON(json: any): AssuranceGridDto {
    return AssuranceGridDtoFromJSONTyped(json, false);
}

export function AssuranceGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssuranceGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocialCompagnieAssurance': !exists(json, 'idsiegeSocialCompagnieAssurance') ? undefined : json['idsiegeSocialCompagnieAssurance'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'compagnieAssurance': !exists(json, 'compagnieAssurance') ? undefined : json['compagnieAssurance'],
        'numeroPolice': !exists(json, 'numeroPolice') ? undefined : json['numeroPolice'],
    };
}

export function AssuranceGridDtoToJSON(value?: AssuranceGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocialCompagnieAssurance': value.idsiegeSocialCompagnieAssurance,
        'idsiegeSocial': value.idsiegeSocial,
        'compagnieAssurance': value.compagnieAssurance,
        'numeroPolice': value.numeroPolice,
    };
}

